module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-2000.f64f70b4.svg";